<template>
  <div
    class="chat_message_image"
    :class="!endLoad ? 'defult' : ''"
    :id="message.msgId"
  >
    <img
      :class="isLoadError ? 'isLoadError' : ''"
      :src="url"
      :style="{
        width: width == 0 ? 180 + 'px' : width + 'px',
        height: newHeight + 'px'
      }"
      v-show="endLoad"
      @click.stop="imageClick"
    />
    <div
      v-show="!endLoad"
      class="isLoading"
      :style="{
        width: width == 0 ? 180 + 'px' : width + 'px',
        height: newHeight + 'px',
        lineHeight: newHeight + 'px'
      }"
      @click.stop="imageClick"
    >
      <i
        class="el-icon-loading"
        v-show="!isLoadError"
        :style="{ fontSize: fontSize + 'px' }"
      />
      <i
        v-show="isLoadError"
        class="el-icon-download"
        :style="{ fontSize: fontSize + 'px' }"
      />
    </div>
    <!-- <div v-show="!endLoad" class="isLoading">
      <i class="el-icon-loading" />
      <p>图片加载中</p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "chatMessageImage",
  data() {
    return {
      url: null,
      endLoad: false,
      timer: null,
      isLoadError: false,
      newHeight: null,
      fontSize: 40
    };
  },
  props: {
    message: {
      type: Object,
      default: () => {}
    },
    imgSrc: {
      type: String
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.setImageAttribute();
  },
  mounted() {
    this.initImage();
  },
  methods: {
    setImageAttribute() {
      if (this.width >= 180) {
        this.newHeight = (180 * this.height) / this.width;
      }
      if (this.newHeight < 100) {
        this.fontSize = 20;
      } else {
        this.fontSize = 40;
      }
    },
    imageClick() {
      if (this.isLoadError) {
        clearTimeout(this.timer);
        this.endLoad = false;
        this.isLoadError = false;
        this.initImage();
      } else {
        this.$emit("clickImage", this.message);
      }
    },
    initImage() {
      var newImg = new Image();
      if (this.imgSrc) {
        newImg.src = this.imgSrc;
      } else {
        newImg.src = this.message.localPath || this.message.filePath;
      }
      newImg.onerror = () => {
        // 图片加载错误时的替换图片
        console.log("加载错误");
        // this.url = require("src/assets/imgs/image_error.png");
        // this.endLoad = true;
        this.isLoadError = true;
      };
      newImg.onload = () => {
        // 图片加载成功后把地址给原来的img
        //  this.isLoadError = true;
        this.url = newImg.src;
        this.endLoad = true;
      };

      this.timer = setTimeout(() => {
        if (!this.endLoad) {
          // this.url = require("src/assets/imgs/image_error.png");
          this.isLoadError = true;
        }
      }, 60 * 1000);
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>
<style lang="less">
.chat_message_image {
  position: relative;
  img {
    cursor: zoom-in;
    background-color: #fff;
  }

  .isLoadError {
    cursor: pointer !important;
  }

  .isLoading {
    background-color: #fff;
    text-align: center;
    // position: absolute;
    // top: 0;
    // left: 0;
    background-color: #7f7f7f;
    i {
      font-size: 140px;
    }

    p {
      font-size: 32px;
      margin-top: 8px;
    }
  }
}
</style>
